import React, { useState, useEffect } from 'react';
import { Modal, message, Popover, Button, Icon, Select } from 'antd';
import BatchFilters from './BatchFilters';
import { BatchDetailsContainer } from './batchDetailsStyles';
import { getBatchDetails, fetchAllPrinters, rePrint } from '../../utils/services/mailRoomAPI';
import DataTable from './DataTable';
import { withTranslation } from 'react-i18next';
import { PRINT_FAILURE_TABLE } from './translationValues';
import { getWeek } from '../../utils/javascript';

const NAMESPACES = ['PRINT_FAILURE_TABLE']
const { Option } = Select;

const BatchDetails = props => {
  const { batchData, printFailures, getTagDetails, startAndEndDate, onCancel, tagValues, dateFilterApplied, t } = props;

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [sortFilter, setSortFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);
  const [filtersInfo, setFiltersInfo] = useState(null);
  const [dataCount, setDataCount] = useState(0);
  const [docPagesCount, setDocPagesCount] = useState(0);
  const [filterSection, setFilterSection] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedPages, setSelectedPages] = useState(0);

  const [printerList, setPrinterList] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState(undefined);
  const [rePrintLoading, setRePrintLoading] = useState(false);
  const [rePrintPopover, setRePrintPopover] = useState(false);

  useEffect(() => {
    fetchPrintersList();
    updateBatchDetails();
  }, []);

  useEffect(() => {
    if (selectedAll) {
      let selectedKeys = [];
      let dummydata = tableData.map((row, key) => {
        selectedKeys.push(row.id);
      });
      setSelectedRowKeys(selectedKeys);
    }
  }, [tableData]);

  const updateBatchDetails = async (pagination, filters, sorter, refreshed = false) => {
    setLoading(true);
    setCurrentPage(pagination);
    let payload = {
      page: pagination ? pagination.current : 1,
      limit: 8,
    };
    if (filters) {
      setFiltersInfo(filters);
      Object.keys(filters).forEach(key => {
        if (filters[key].length === 0) {
          delete filters[key];
        }
      });
      payload = { ...payload, ...filters };
    }
    if (sorter) {
      setSortFilter(sorter);
      if (sorter.order !== undefined) {
        payload.sortby = sorter.columnKey;
        payload.sortorder = sorter.order.substring(0, sorter.order.length - 3);
      }
    }
    if (printFailures) {
      payload.printStatus = 'Failed';
      payload.jobCreatedOnTo = startAndEndDate.endDate;
      payload.jobCreatedOnFrom = startAndEndDate.startDate;
      if(!dateFilterApplied) {
        let currentWeek = getWeek();
        payload.jobCreatedOnFrom = currentWeek.startDate;
        payload.jobCreatedOnTo = currentWeek.endDate;
      }
    } else {
      payload.batchId = batchData.id;
    }
    if(refreshed) {
      payload.reloadStatus = true;
      if(!printFailures) {
        payload.printerName = batchData.printerName;
      }      
    }
    const response = await getBatchDetails(payload);

    if (response.error === 'Internal Server Error') {
      message.error(t(PRINT_FAILURE_TABLE.SOMETHING_WRONG_ERROR_MESSAGE.key, PRINT_FAILURE_TABLE.SOMETHING_WRONG_ERROR_MESSAGE.value));
      setLoading(false);
    }
    if (response && response.errors && response.errors.length === 0) {
      if (response && response.data) {
        setDataCount(response.dataCount);
        setDocPagesCount(response.totalPagesCount);
        setTableData(response.data);
        setLoading(false);
      }
    }
  };

  const onRefresh = () => {
    updateBatchDetails(currentPage, filtersInfo, sortFilter, true);
  };
  const handleVisibleChange = visible => {
    setRePrintPopover(visible);
  };

  const fetchPrintersList = async () => {
    const response = await fetchAllPrinters();
    if (response && response.errors && response.errors.length === 0) {
      if (response && response.data) {
        setPrinterList(response?.data);
        setSelectedPrinter(response?.data[0].id);
      }
    }
  };

  const onRePrint = async () => {
    setRePrintLoading(true);
    let payload = {};
    if (selectedAll) {
      if (printFailures) {
        payload.printStatus = 'Failed';
      } else {
        payload.id = batchData.id;
      }
      if (filtersInfo)
        Object.keys(filtersInfo).map(key => {
          if (key === 'docName') {
            payload.nameSearched = filtersInfo[key].toString();
          } else if (key === 'batchName') {
            payload.name = filtersInfo[key].toString();
          } else if(key === 'docPages') {
            payload.documentPages = parseInt(filtersInfo[key]);
          } else {
            if (filtersInfo[key].length > 0) payload[key] = filtersInfo[key].toString();
          }
        });
    } else {
      payload.mailRoomDocumentIds = selectedRowKeys;
    }
    payload.printerId = selectedPrinter;
    const response = await rePrint(payload);
    if (response) {
      if (response.errors && response.errors.length === 0) {
        message.success(t(PRINT_FAILURE_TABLE.REPRINT_INITIATED_SUCCESS_MESSAGE.key, PRINT_FAILURE_TABLE.REPRINT_INITIATED_SUCCESS_MESSAGE.value));
        setRePrintPopover(false);
        setSelectedAll(false);
        setSelectedPages(0);
        setSelectedRowKeys([]);
        onRefresh();
      }
      setRePrintLoading(false);
    }
  };

  const content = () => {
    return (
      <>
        <Select
          showSearch
          style={{ width: 200 }}
          placeholder={t(PRINT_FAILURE_TABLE.SELECT_PRINTER_PLACEHOLDER.key, PRINT_FAILURE_TABLE.SELECT_PRINTER_PLACEHOLDER.value)}
          optionFilterProp="children"
          onChange={e => setSelectedPrinter(e)}
          defaultValue={printerList[0].printerName}
        >
          {printerList.map((li, key) => {
            return (
              <Option value={li.id} key={key}>
                {li.printerName}
              </Option>
            );
          })}
        </Select>
        <Button
          type="primary"
          loading={rePrintLoading}
          style={{ marginLeft: '12px' }}
          onClick={() => {
            onRePrint();
          }}
        >
          {rePrintLoading ? t(PRINT_FAILURE_TABLE.PRINTING_LOADING_MESSAGE.key, PRINT_FAILURE_TABLE.PRINTING_LOADING_MESSAGE.value) : t(PRINT_FAILURE_TABLE.RE_PRINT_BUTTON.key, PRINT_FAILURE_TABLE.RE_PRINT_BUTTON.value)}
        </Button>
      </>
    );
  };

  return (
    <Modal
      width={'98%'}
      centered
      closable={true}
      placement="right"
      onCancel={() => onCancel()}
      visible={true}
      footer={[]}
      className="mailRoomDoc_modal"
    >
      <BatchDetailsContainer filterSection={filterSection} printFailures={printFailures}>
        <div className="title">{printFailures ? t(PRINT_FAILURE_TABLE.PRINT_FAILURES_TABLE_TITLE.key, PRINT_FAILURE_TABLE.PRINT_FAILURES_TABLE_TITLE.value) : batchData.name}</div>
        <div className="reprintContainer">
          {selectedRowKeys.length > 0 && (
            <div>
              <p className="count">
                {t(PRINT_FAILURE_TABLE.TOTAL_DOCMENTS.key, PRINT_FAILURE_TABLE.TOTAL_DOCMENTS.value, { page: selectedAll ? docPagesCount : selectedPages, document: selectedAll ? dataCount : selectedRowKeys.length })}
              </p>
              <Popover
                content={content()}
                title={t(PRINT_FAILURE_TABLE.SELECT_PRINTER_POPUP_TITLE.key, PRINT_FAILURE_TABLE.SELECT_PRINTER_POPUP_TITLE.value)}
                trigger="click"
                visible={rePrintPopover}
                onVisibleChange={visible => handleVisibleChange(visible)}
              >
                <Button>{t(PRINT_FAILURE_TABLE.RE_PRINT_BUTTON.key, PRINT_FAILURE_TABLE.RE_PRINT_BUTTON.value)}</Button>
              </Popover>
            </div>
          )}
          <a
            onClick={() => onRefresh()}
            style={{ marginTop: selectedRowKeys.length < 1 && '8px' }}
          >
            <Icon type="reload" />
            {t(PRINT_FAILURE_TABLE.REFRESH_ACTION.key, PRINT_FAILURE_TABLE.REFRESH_ACTION.value)}
          </a>
        </div>
        {batchData && (
          <BatchFilters
            filterSection={filterSection}
            setFilterSection={setFilterSection}
            batchData={batchData}
            getTagDetails={getTagDetails}
          />
        )}
        <DataTable
          inQueueCount={batchData?.inqueueCount}
          printFailures={printFailures}
          tagValues={tagValues}
          tableData={tableData}
          dataCount={dataCount}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          selectedPages={selectedPages}
          setSelectedPages={setSelectedPages}
          selectedAll={selectedAll}
          setSelectedAll={setSelectedAll}
          updateBatchDetails={updateBatchDetails}
          loading={loading}
        />
      </BatchDetailsContainer>
    </Modal>
  );
};

export default withTranslation(NAMESPACES)(BatchDetails);
